import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../appReducer';
import { TestCategory, TestType } from '../order/types';
import ordersSlice from '../ordersTable/ordersSlice';
import {
  OnChangeSortType,
  OrdersStateTypes,
  UseOrdersFiltersTypes,
} from '../ordersTable/types';
import { OnPageChangedType } from '@root/src/app/designSystem/pagination/types';
import { NullableString } from '@app/common/types';

const useOrdersFilters = (): UseOrdersFiltersTypes => {
  const { filters } = useSelector((state: RootState) => state.orders);
  const dispatch = useDispatch();
  const {
    setPageNumber,
    setSorting,
    setFilters,
    setSearchText,
  } = ordersSlice.actions;

  const onPageChanged: OnPageChangedType = (currentPage: number) => {
    if (filters.page !== currentPage) {
      dispatch(setPageNumber(currentPage));
      window.scrollTo(0, 100);
    }
  };

  const onChangeSort: OnChangeSortType = (sortObj) => {
    dispatch(setSorting(sortObj));
  };

  const ordersStateChange = (ordersState: OrdersStateTypes) => {
    dispatch(
      setFilters({
        ...filters,
        ordersState: ordersState,
        page: 1,
      })
    );
  };

  const onSetFilterDate = (date: NullableString) => {
    dispatch(
      setFilters({ ...filters, page: 1, startDate: date, endDate: date })
    );
  };

  const onChangeSearchText = (value: string): void => {
    dispatch(setSearchText(value));
  };

  const onChangeTestFilter = (type: TestType, category: TestCategory): void => {
    dispatch(setFilters({ ...filters, page: 1, type, category }));
  };

  return {
    onPageChanged,
    onChangeSort,
    ordersStateChange,
    onChangeSearchText,
    onSetFilterDate,
    onChangeTestFilter,
    filters,
  };
};

export default useOrdersFilters;
